export default __webpack_public_path__ + "59874533b55c858beb019a38fcac512f.svg";